import { DedicatedPackageOutput } from '@allocab/allocab-dedicated-driver-types';
import { useState } from 'react';

import { useRefuseTriPackageToDriver } from '../../hooks/useRefuseTriPackageToDriver';
import { ToastManager } from '../../services/toast/utils';
import { t } from '../../services/translation/translation';
import { getFullName } from '../../utils/common';
import { DangerButton } from '../button/DangerButton';
import { ConfirmationModal } from '../modal/ConfirmationModal';

type Props = {
  tripPackage: DedicatedPackageOutput;
  driverKey: string;
};

export const TripPackageRefuseButton = ({ tripPackage, driverKey }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { mutate: refuseTripPackage, isLoading } = useRefuseTriPackageToDriver(tripPackage.id);

  const handleRefuse = () => {
    refuseTripPackage(
      { driverKey: driverKey },
      {
        onSuccess: () => {
          setIsOpen(false);
          ToastManager.show({
            severity: 'success',
            message: t('trip-package.refuse-modal.success', {
              driverName: getFullName(tripPackage.driver?.firstName, tripPackage.driver?.lastName),
            }),
          });
        },
      },
    );
  };

  return (
    <>
      <DangerButton onClick={() => setIsOpen(true)}>{t('common.refuse')}</DangerButton>
      {isOpen ? (
        <ConfirmationModal
          title={t('trip-package.refuse-title')}
          isLoading={isLoading}
          onClose={() => setIsOpen(false)}
          onConfirm={handleRefuse}
          confirmLabel={t('trip-package.refuse-title')}
          type="danger"
        >
          <p className="mb-0">
            {t('trip-package.refuse-text', {
              driverName: getFullName(tripPackage.driver?.firstName, tripPackage.driver?.lastName),
            })}
          </p>
        </ConfirmationModal>
      ) : null}
    </>
  );
};
